import { render, staticRenderFns } from "./FacturasDetail.vue?vue&type=template&id=85d4edda&"
import script from "./FacturasDetail.vue?vue&type=script&lang=js&"
export * from "./FacturasDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports